module.exports = __webpack_public_path__ + "static/media/C13.795f444c.png";